import { render, staticRenderFns } from "./MilestoneDetailModal.vue?vue&type=template&id=6fc05cf8&scoped=true"
import script from "./MilestoneDetailModal.vue?vue&type=script&lang=js"
export * from "./MilestoneDetailModal.vue?vue&type=script&lang=js"
import style0 from "./MilestoneDetailModal.vue?vue&type=style&index=0&id=6fc05cf8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc05cf8",
  null
  
)

export default component.exports